import { IContactAddressState } from '@r1-frontend/entities/ContactAddress/initialState';

export const isAddressFilled = (state: IContactAddressState): boolean => {
    const {
        contactAddress: {
            editedAddressData,
        },
    } = state;

    const {
        street,
        house,
        flat,
    } = editedAddressData || {};

    return Boolean(street?.value) && Boolean(house?.value) && Boolean(flat);
};
